// @ts-nocheck
import React from 'react'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { Step } from './common/Step/Step'

import styles from './ProgressWidget.module.scss'

export const ProgressWidget = ({
  steps = [],
  progress = 0,
  label = '',
  queries = null,
  tabs = null,
  onClick,
}) => (
  <Box
    align="center"
    className={styles.widget}
    direction="column"
    tagName="span"
  >
    <Box
      align="center"
      className={styles.steps}
      justify="center"
      tagName="span"
    >
      {R.addIndex(R.map)((title, idx) => {
        const activeTab = tabs(idx)
        const query = queries({ activeTab })

        return (
          <Step
            className={styles.step}
            key={idx}
            title={title}
            isIncomplete={idx >= progress}
            onClick={onClick ? () => onClick(activeTab, query) : null}
          />
        )
      }, steps)}
    </Box>
    <span className={styles.label}>{label}</span>
  </Box>
)
